import React, { forwardRef } from 'react';
import { renderToString } from 'react-dom/server';
import PropTypes from 'prop-types';
import { filter } from 'lodash';
import classNames from 'classnames';
import ExpandableList from 'components/ExpandableList';
import CardProductB from 'components/CardProduct/CardProductB';
import ImageA from 'components/Image/ImageA';
import classes from './PackageTabCContent.module.scss';

const PackageTabCContent = forwardRef((props, ref) => {
  const {
    onTransitionEnd,
    isActive,
    heading,
    topCopy,
    bottomCopy,
    categories = [],
    packageAttributes = [],
    locations = [],
    renderContentSection,
    products,
    image,
  } = props;

  const {
    imageURI,
    imageAltText,
  } = image || {};

  const imageElement = imageURI && (
    <ImageA
      className={classes.image}
      url={imageURI}
      alt={imageAltText}
      width={400}
      height={260}
      loading='lazy'
      aria-hidden
    />
  );

  function renderExpandableBody(attrImage, description) {
    return renderToString(
      <div className={classes.contentWrapper}>
        <ImageA
          className={classes.attrImage}
          width={95}
          height={95}
          {...attrImage}
        />
        <div dangerouslySetInnerHTML={{ __html: description }} />
      </div>,
    );
  }

  function renderAttributes() {
    return (
      categories.map((c, index) => {
        const { title: categoryTitle, attributes = [] } = c;
        const packageTabAttributes = filter(attributes, ({ title }) => packageAttributes.includes(title));
        return (
          packageTabAttributes.length > 0 &&
          <div className={classes.categoryContainer} key={`${categoryTitle}-${index}`}>
            <div
              className={classes.categoryTitle}
              dangerouslySetInnerHTML={{ __html: categoryTitle }}
            />
            <ExpandableList
              type='ExpandableListItemA'
              renderStructuredData={false}
              items={
                packageTabAttributes
                  .map(({ displayText, description, image: attrImage }) => (
                    { title: displayText, body: renderExpandableBody(attrImage, description) }))
              }
            />
          </div>
        );
      }));
  }

  return (
    <div
      className={classNames(classes.main, !isActive && classes.hide)}
      ref={ref}
      onTransitionEnd={onTransitionEnd}
    >
      <div className={classes.column}>
        {renderContentSection(
          topCopy,
          locations.top,
        )}
        {renderContentSection(
          renderAttributes(packageAttributes),
          locations.attributes,
        )}
      </div>
      <div className={classes.column}>
        {imageElement &&
          <div className={classes.imageContainer}>
            {imageElement}
          </div>}
        {heading &&
          <h4
            dangerouslySetInnerHTML={{ __html: heading }}
          />}
        <CardProductB items={products} hideLeftIcon />
      </div>
      <div className={classes.contentFooter}>
        {renderContentSection(
          bottomCopy,
          locations.bottom,
        )}
      </div>
    </div>
  );
});

const AttributeT = PropTypes.shape({
  title: PropTypes.string,
  displayText: PropTypes.string,
  shortCopy: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.object,
});

const CategoryT = PropTypes.shape({
  title: PropTypes.string,
  attributes: PropTypes.arrayOf(AttributeT),
});

PackageTabCContent.propTypes = {
  onTransitionEnd: PropTypes.func,
  isActive: PropTypes.bool,
  heading: PropTypes.string,
  topCopy: PropTypes.string,
  bottomCopy: PropTypes.string,
  categories: PropTypes.arrayOf(CategoryT),
  packageAttributes: PropTypes.arrayOf(PropTypes.string),
  locations: PropTypes.object,
  products: PropTypes.array,
  renderContentSection: PropTypes.func,
  image: PropTypes.shape({
    imageURI: PropTypes.string,
    imageAltText: PropTypes.string,
  }),
};

export default PackageTabCContent;
